<template lang="pug">
  .b2b-page-download-invoice
    transition(name="fade" mode="out-in")
      router-view
</template>

<script>
import { mapActions } from 'vuex'
import router from '@/router/index'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-download-invoice',
  mixins: [Utils],
  methods: {
    ...mapActions([
      'B2bCreateConfig',
      'parseUserAuthorities',
      'getInvoiceNoteByTokenLink',
      'handleDownloadMultiInvoiceNotesPdf'
    ]),
    async handleDownloadInvoicePdf (invoiceId) {
      console.log('handleDownloadInvoicePdf: ', invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })
      try {
        const idList = [invoiceId]
        const filename = await this.handleDownloadMultiInvoiceNotesPdf({
          invoiceNoteId: idList,
          searchType: this.searchType
        })
        load.close()
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadInvoicePdf CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 404:
        case 409:
          errorSms = error.data.message
          break
        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error, 10000)
    }
  },
  async created () {
    const action = this.$route.params.action // Recoge el parámetro action de la ruta: download o detail
    if (this.$route.query && this.$route.query.token) {
      let params = null
      // si viene el id en la url:
      if (this.$route.query.id) {
        params = {
          invoiceId: this.$route.query.id,
          token: this.$route.query.token
        }
      } else if (this.$route.query.seller && this.$route.query.buyer && this.$route.query.issuedate && this.$route.query.invoicenumber) {
        // si no viene el id en la url:
        // se busca por el token y el resto de datos que vienen en la url
        params = {
          token: this.$route.query.token,
          sellerNif: this.$route.query.seller,
          buyerNif: this.$route.query.buyer,
          issueDate: this.$route.query.issuedate,
          invoiceNumber: this.$route.query.invoicenumber
        }
      } else {
        this.$notify({
          title: this.$t('ocr.send_ocr_document.confirm.params_required'),
          type: 'error',
          position: 'top-right',
          customClass: 'b2b-notification-error',
          duration: 10000
        })
      }
      // Buscamos la factura por el token y el resto de datos que vienen en la url
      const factura = await this.getInvoiceNoteByTokenLink(params)
      this.parseUserAuthorities()
      this.searchType = 'EMITTED'
      if (!factura.emission) {
        this.searchType = 'RECEIVED'
      }
      if (action === 'detail') {
        console.log('>>>> ENTRO DETAIL <<<<')
        // Si el action es detail, se redirige a la página de detalle de la factura
        // Redirigir a la página de facturas emitidas/recibidas
        const page = this.searchType === 'EMITTED' ? 'factura-emitida-detail' : 'factura-recibida-detail'
        sessionStorage.setItem('invoiceNumber', factura.invoiceNumber)
        router.push({
          name: page,
          params: {
            invoiceNoteId: factura.id,
            redirectedFrom: 'B2bPageDownloadInvoice'
          }
        })
      } else if (action === 'download') {
        console.log('>>>> ENTRO DOWNLOAD <<<<')
        // Si el action es download, se descarga la factura PDF
        this.handleDownloadInvoicePdf(factura.id)
      }
    }
    // this.B2bCreateConfig()
  }
}
</script>

<style lang="scss" scoped>

</style>
